import React from "react";
import { Button } from "react-bootstrap";
import io from "socket.io-client";
import { sendNumber, sendReset } from "./api";

const handlePost = (d) => {
  fetch("https://numbers.inspectron.ch/numbers/" + d, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoxLCJ1c2VybmFtZSI6ImFkbWluIn0sImlhdCI6MTU0NDUyNjExNX0.62cIOAZ6jOw9gSyUtsXYBcmHpUec8707HuhRUO7RSaM"
    }
  });
  // Socket
  sendNumber(d);
  console.log("fired")
}


const ButtonArray = props => (


  
  <div>
    {props.data.map(d => (
        // Button that POSTS the number to the API and sends it with the Socket to the Client
      <Button
        bsSize="large"
        key={d}
        onClick={() => {handlePost(d)}}
      >
        {d}
      </Button>
    ))}
    <br /> <br />
    <br />
    <Button
      bsStyle="danger"
      bsSize="large"
      block
      onClick={() =>
        {
          fetch("https://numbers.inspectron.ch/numbers/reset", {
          //fetch('https://numbers.inspectron.ch/numbers/reset', {
          method: "DELETE",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VyIjp7ImlkIjoxLCJ1c2VybmFtZSI6ImFkbWluIn0sImlhdCI6MTU0NDUyNjExNX0.62cIOAZ6jOw9gSyUtsXYBcmHpUec8707HuhRUO7RSaM"
          }
        })
        sendReset("RESET");
      }
      }
    >
      DELETE
    </Button>
  </div>
);

export default ButtonArray;



// WEBPACK FOOTER //
// ./src/components/ButtonArray.jsx